"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRangePickerAltText = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _interfaces = require("../interfaces");

var getRangePickerAltText = function getRangePickerAltText(altTextParam, inputRole) {
  if ((0, _typeof2.default)(altTextParam) !== 'object') {
    return altTextParam;
  }

  return inputRole === _interfaces.DateInputRole.StartDate ? altTextParam.startDate : altTextParam.endDate;
};

exports.getRangePickerAltText = getRangePickerAltText;